// extracted by mini-css-extract-plugin
module.exports = {"sustainability":"Sustainability_sustainability__wfyyO","text":"Sustainability_text__vdFYL"};